import { connect } from 'react-redux';
import { change } from 'redux-form';
import {
  setBopisFilterState,
  setConsolidatedPlpRes,
} from '@tcp/core/src/components/features/browse/CategoryListingPage/container/CategoryListingPage.actions';
import { getDefaultFavStore } from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { getFilterMaps } from '@tcp/core/src/components/features/browse/CategoryListingPage/container/CategoryListingPage.selectors';
import {
  getIsOneHrFilterEnabled,
  getSeoFacetedNavigationConfig,
  getIsFacetedNavigationEnabled,
  getIsCleanUrlForSizeEnabled,
  getIsDisplayPickupTimeEnabled,
  getStoreHoursThreshold,
  getIsFullDateDisplayEnabled,
  allowOnlineProductPickup,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { setClickAnalyticsData, trackClick } from '@tcp/core/src/analytics/actions';
import {
  resetStoresByCoordinates,
  setFavoriteStoreActn,
} from '@tcp/core/src/components/features/storeLocator/StoreLanding/container/StoreLanding.actions';
import constants from '@tcp/core/src/components/features/storeLocator/StoreLanding/container/StoreLanding.constants';
import OneHrFilter from '../views/OneHrFilter.view';
import submitProductListingFiltersForm from '../../ProductListing/container/productListingOnSubmitHandler';
import getIsBopisFilterOn, { getFormValuesForOneHrFilter } from './OneHrFilter.selector';

const { STORE_LOCATOR } = constants;

const mapStateToProps = (state, ownProps) => ({
  defaultStore: getDefaultFavStore(state),
  isBopisFilterOn: getIsBopisFilterOn(state, ownProps),
  isOneHrFilterEnabled: getIsOneHrFilterEnabled(state),
  filterMaps: getFilterMaps(state),
  seoFacetedNavigationConfig: getSeoFacetedNavigationConfig(state),
  formValues: getFormValuesForOneHrFilter(state, ownProps),
  isFacetedNavigationEnabled: getIsFacetedNavigationEnabled(state),
  isCleanUrlForSizeEnabled: getIsCleanUrlForSizeEnabled(state),
  isDisplayPickupTimeEnabled: getIsDisplayPickupTimeEnabled(state),
  storeHoursThreshold: getStoreHoursThreshold(state),
  isFullDateDisplayEnabled: getIsFullDateDisplayEnabled(state),
  shouldAllowOnlineProductPickup: allowOnlineProductPickup(state),
});

const mapDispatchToProps = (dispatch) => ({
  updateBopisFormValue: (field, value) => {
    dispatch(change('filter-form', field, value));
  },
  setBopisFilterStateActn: (payload) => {
    dispatch(setBopisFilterState(payload));
  },
  setUpdatedUrlActn: (payload) => {
    dispatch(setConsolidatedPlpRes(payload));
  },
  trackClickAnalyticsBopisFilter: (payload) => {
    dispatch(setClickAnalyticsData(payload));
    const timer = setTimeout(() => {
      dispatch(trackClick(payload));
      clearTimeout(timer);
    }, 250);
  },
  resetSuggestedStores: (payload) => dispatch(resetStoresByCoordinates(payload)),
  trackAnalyticsClick: (eventData, payload) => {
    dispatch(setClickAnalyticsData(eventData));
    const timer = setTimeout(() => {
      dispatch(trackClick(payload));
      clearTimeout(timer);
    }, 100);
  },
  onSubmit: submitProductListingFiltersForm,
  setFavoriteStore: (payload) => dispatch(setFavoriteStoreActn({ ...payload, key: STORE_LOCATOR })),
});

const OneHrFilterContainer = connect(mapStateToProps, mapDispatchToProps)(OneHrFilter);
export default OneHrFilterContainer;
